import React, { useContext } from 'react';
import { BsPinFill } from 'react-icons/bs';

import { FilterContext } from '~/context/filter';
import { ColorContainer } from './Components/ColorContainer';
import { BoxColorPreview } from './Components/BoxColorPreview';
import { useCards } from '../CardContext';
import { BootstrapModal } from './styles';

import { InputText } from '~/components/NovosInputs';
import { HotKeys, configure } from 'react-hotkeys';
import { useHotkeys } from 'react-hotkeys-hook';
import useDebounce from '~/hooks/useDebounce';
import { DefaultView } from './Components/DefaultView';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { SeparatorNovo } from '~/components/SeparatorNovo';

export const ModalCard: React.FC<{ enableExcluir: boolean }> = ({
  enableExcluir,
}) => {
  const {
    showTable,
    setUpdateCard,
    isUpdateCard,
    isCardFixed,
    setIsCardFixed,
    codTelaProp,
    isOpenModal,
    setIsOpenModal,
    handleDeleteCard,
    handleSubmitCard,
    handleClearCard,
    isOpenPickerColor,
    setisOpenPickerColor,
    queryClient,
    register,
    errors,
    setValue,
    control,
    colorWatch,
    clearErrors,
    codCard,
    setCodCard,
    cardSubmitted,
  } = useCards();

  const { debouncedFn } = useDebounce();

  configure({
    ignoreTags: ['input', 'select', 'textarea', 'button'],
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ignoreEventsCondition(keyEvent: KeyboardEvent) {
      return false;
    },
  });

  const { RemoveAllFilter } = useContext(FilterContext);

  // useEffect(() => {
  //   if (!isOpenModal) return;

  //   // Aguardar um pouco para garantir que os dados estejam disponíveis
  //   const timeout = setTimeout(() => {
  //     const codCardOnSearch: any =
  //       queryClient.getQueryData(`infoCardAtivo_${codTelaProp}`) || undefined;

  //     if (codCardOnSearch) {
  //       setUpdateCard(true);
  //       setValue('name', codCardOnSearch.des_card);
  //       setValue('color', codCardOnSearch.cor);
  //       // Definir isCardFixed baseado nos dados do card
  //       const shouldBeFixed =
  //         codCardOnSearch.cod_card === codCardOnSearch.cod_card_fixado;
  //       setIsCardFixed(shouldBeFixed);
  //     }
  //   }, 100);

  //   debouncedFn(() => {
  //     const input = document.querySelector('[name="name"]') as HTMLInputElement;
  //     input?.focus();
  //   }, 500);

  //   // focus
  //   return () => clearTimeout(timeout);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isOpenModal]);

  useHotkeys(
    'ctrl+alt+s',
    (event) => {
      event.preventDefault();
      if (isOpenModal) {
        handleSubmitCard();
      }
    },
    [],
  );

  const keyMap = {
    hkSave: 'ctrl+alt+s',
  };

  const keyHandlers = {
    hkSave: async () => {
      if (isOpenModal) {
        await handleSubmitCard();
        return false;
      }
    },
  };

  return (
    <HotKeys id="hotkeys" keyMap={keyMap} handlers={keyHandlers} tabIndex={-1}>
      <BootstrapModal
        show={isOpenModal}
        onClick={() => {
          setisOpenPickerColor(false);
        }}
        onHide={() => {
          setIsOpenModal(false);

          if (!showTable) {
            setUpdateCard(false);
            setCodCard(undefined);
            handleClearCard();
          }

          if (!codCard) {
            setUpdateCard(false);
            handleClearCard();
          }
        }}
        style={{ marginTop: '25px' }}
        centered
        size="xl"
      >
        <BootstrapModal.Header>
          <BoxColorPreview
            color={colorWatch}
            setColorPreview={(cor) => setValue('color', cor)}
            setShouldOpenPicker={setisOpenPickerColor}
            shouldOpenPicker={isOpenPickerColor}
          />

          <div className="textFieldContainer">
            <div>
              <InputText
                maxLength={50}
                label="Descrição"
                caseInput="upper"
                placeholder="Digite aqui a Descrição"
                name="name"
                control={control}
                toLowerCase={false}
                register={register}
                onBlur={(e) => {
                  debouncedFn(() => {
                    if (e.target.value.length > 0) {
                      clearErrors('name');
                    }
                  }, 600);
                }}
                isError={!!errors.name}
              />
            </div>
          </div>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          <DefaultView
            register={register}
            control={control}
            setValue={setValue}
            cod_tela={codTelaProp}
            showTable={showTable}
            cardSubmitted={cardSubmitted}
          />
          {/* <TiposAcessos /> */}
          <br />
          <span>Escolha uma cor:</span>
          <div className="pickerColorContainer">
            <ColorContainer
              setPickerColor={(cor: any) => {
                setValue('color', String(cor));
              }}
            />
          </div>
        </BootstrapModal.Body>
        <BootstrapModal.Footer>
          <SeparatorNovo marginTop={-35} />
          <div className="containerLeft">
            <CustomButtonNovo
              onClick={() => {
                setIsCardFixed(!isCardFixed);
              }}
              width="100%"
              outline
            >
              <BsPinFill
                id="fixarcard"
                title={isCardFixed ? 'Desafixar Busca' : 'Fixar Busca'}
                style={{
                  color: isCardFixed ? '#FF9900' : '#7C7C7C',
                }}
              />
              <label htmlFor="fixarcard" style={{ cursor: 'pointer' }}>
                Fixar essa busca?
              </label>
            </CustomButtonNovo>
          </div>
          <div
            className="containerRight"
            style={{ minWidth: isUpdateCard ? '250px' : '150px' }}
          >
            <CustomButtonNovo
              onClick={async () => {
                await handleSubmitCard();
              }}
              variant="clear"
              data-toggle="tooltip"
              title="CTRL + ALT + S"
              label="Salvar"
              width="5rem"
            />

            {isUpdateCard && enableExcluir && (
              <CustomButtonNovo
                onClick={() => {
                  if (showTable === false) {
                    RemoveAllFilter(codTelaProp);
                  }
                  handleDeleteCard();
                }}
                variant="error"
                label="Excluir"
                width="5rem"
              />
            )}
            <CustomButtonNovo
              onClick={() => {
                if (!showTable) {
                  setCodCard(undefined);
                  setUpdateCard(false);
                }
                handleClearCard();
                setIsOpenModal(false);
              }}
              variant="cancel"
              label="Cancelar"
              width="5rem"
            />
          </div>
        </BootstrapModal.Footer>
      </BootstrapModal>
    </HotKeys>
  );
};
